package space.stanton.config

import com.varabyte.kobweb.core.AppGlobals

object Globals {
//    val appVersion: String get() = AppGlobals["version"] ?: "Missing version"
//    val gitCommit: String get() = AppGlobals["gitCommit"] ?: "Unknown"
    val isDebug: Boolean get() = AppGlobals["buildType"] == "DEBUG"
//    val env: Environment get() = Environment.from(AppGlobals["env"])
}